import { createContext, useContext } from "react";

export const AppFormModalDataContext = createContext({
  initialFormData: null,
  formInstance: null,
});
export const useAppFormModalDataContext = () =>
  useContext(AppFormModalDataContext);
